module.exports = __webpack_public_path__ + "img/dummy-tutor.a793b1f6.jpg";